module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/_readable-stream@2.3.8@readable-stream/lib/internal/streams/stream-browser.js
// module id = 327
// module chunks = 0